import api from './api';

// Admin › Infra › Pegasus Diverter — legacy Pegasus sources the legacy stack forwards to the hub (pegasus_diverter on
// the legacy database, served by the ui-v2-legacyingress lambda). A source is <chainCode>/<hotelCode>/<username>; no
// secret is stored (the password never leaves the message and the hub re-checks it).
const pegasusDiverterService = {
    list:   ()         => api.get('/admin/pegasus-diverter'),
    create: (body)     => api.post('/admin/pegasus-diverter', body),         // { chainCode, hotelCode, username, note?, active? }
    update: (id, body) => api.put(`/admin/pegasus-diverter/${id}`, body),    // { active?, note? }
    remove: (id)       => api.delete(`/admin/pegasus-diverter/${id}`),
    // What the hub logged for this source's hotel code through the Pegasus proxy, newest first, plus the legacy side's
    // forwarded count. -> { groups, nextOffset, error?, source, hotelCode, legacy: { calls, lastForwarded }, checkedAt }
    logs: (id, params = {}) => {
        const qs = new URLSearchParams();
        for (const [k, v] of Object.entries(params)) if (v !== undefined && v !== null && v !== '') qs.set(k, String(v));
        return api.get(`/admin/pegasus-diverter/${id}/logs${qs.toString() ? `?${qs}` : ''}`);
    },
};

export default pegasusDiverterService;
